import styled from 'styled-components';

const colors = require('common/lib/colors/colors.less');

export const DetailContainer = styled.div`
  background: ${colors.white};
  border-radius: 4px;
  box-sizing: border-box;
  line-height: 1.33;
  padding: 0.1px 8px; // prevent margin collapsing
`;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-detail/DetailContainer.js